import Guid from 'guid'
import cookies from 'browser-cookies'

const getSession = () => {
  const guid = cookies.get('fineryId')
  if(!guid){  
    const newGuid = Guid.create()
    //console.log('new guid', newGuid)
    cookies.set('fineryId', newGuid.toString(), {expires: 365})
    return newGuid
  }
  return guid
}

export default getSession


// WEBPACK FOOTER //
// ./src/session.js